export const BenefitsSection = () => {
  const stats = [
    {
      title: "25%",
      description: "Average Increase in Student Enrollment",
      color: "from-blue-400 to-blue-600"
    },
    {
      title: "40%",
      description: "Improvement in Digital Engagement",
      color: "from-blue-500 to-blue-700"
    },
    {
      title: "100+",
      description: "Educational Institutions Served",
      color: "from-blue-600 to-blue-800"
    }
  ];

  return (
    <section className="py-20 px-4 bg-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-black mb-4">
            Why Partner With Us?
          </h2>
          <p className="text-lg text-black max-w-2xl mx-auto">
            We understand the unique challenges faced by educational institutions
            in today's digital landscape.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className={`p-8 rounded-lg bg-gradient-to-br ${stat.color} text-white text-center`}
            >
              <div className="text-4xl font-bold mb-2">{stat.title}</div>
              <div className="text-sm opacity-90">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};